module.exports = __webpack_public_path__ + "static/media/tombstone_rip.nolimitcity.c610e279.jpeg";